<template>
  <div
    aria-hidden="true"
    class="artwork">
    <div
      :style="artworkStyle"
      :class="['ratio ratio-1-1', {dark: isDark}]"
    />
  </div>
</template>

<script>
import Store from '../store'

export default {
  data () {
    return {
      store: Store
    }
  },
  computed: {
    artworkStyle () {
      let image = false

      if (this.pod && this.pod.image_url) image = this.pod.image_url
      if (this.epi && this.epi.image_url) image = this.epi.image_url
      if (!image) return image

      return {
        'backgroundImage': `url(${image})`
      }
    },
    epi () { return this.store.state.episode },
    isDark () { return this.store.state.isDark },
    pod () { return this.store.state.podcast }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';

.artwork {
  .sc-logo {
    .sc-logo-border {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import '../assets/styles/breakpoints.scss';

.artwork {
  border-radius: 2px;

  &-default {
    border-radius: 2px;
    height: 60%;
    margin-left: -30%;
    margin-top: -30%;
    left: 50%;
    opacity: .05;
    position: absolute;
    top: 50%;
    width: 60%;
  }
  .ratio {
    background-color: $grey-300;
    background-size: cover;
    border-radius: 2px;
    position: relative;
    &.dark {
      background-color: $grey-700;
    }
  }
}
</style>
